module.exports = __webpack_public_path__ + "media/images/1200/weight_loss_bed-1cb166f1df2338402df962715b96e5ff.webp";